/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import NumberFormat from "react-number-format";
import { Box, Typography, TextField, makeStyles } from "@material-ui/core";
import { useDebounce } from "lib/react/customHooks";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  numberField: {
    marginLeft: "10px",
  },
  padding: {
    padding: theme.spacing(1.5),
  },
  constraintContainer: {
    boxShadow: "0 1px 4px 0 rgba(37, 50, 56, 0.1)",
    borderRadius: "3px",
    marginBottom: "5px",
    backgroundColor: "#fff",
    border: "1px solid #e0e0e0",
  },
  inputValueBox: {
    display: "flex",
    flexDirection: "column",
  },
  inputTitleBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "5px",
  },
}));

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix="$"
    />
  );
}
export default function FormattedInputs({
  inputData,
  constraints,
  handleChange,
}) {
  const classes = useStyles();

  const [numberValue, setNumberValue] = React.useState(
    constraints[inputData.key] || ""
  );

  const debouncedNumberValue = useDebounce(numberValue, 200);

  useEffect(() => {
    handleChange(inputData.key, parseFloat(debouncedNumberValue));
  }, [debouncedNumberValue]);

  return (
    <Box
      component="div"
      className={`${classes.constraintContainer} ${classes.padding}`}
    >
      <Box component="div" className={classes.inputTitleBox}>
        <Typography variant="body2">
          <b>{inputData.label}</b>
        </Typography>
        <TextField
          className={classes.numberField}
          variant="outlined"
          size="small"
          value={numberValue}
          onChange={(event) => {
            setNumberValue(event.target.value);
          }}
          name="numberformat"
          id={inputData.key}
          InputProps={{
            inputComponent: NumberFormatCustom,
          }}
        />
      </Box>
      {/* <Box component="div" className={classes.inputValueBox}>
        <Typography variant="body2">{inputData.description}</Typography>
      </Box> */}
    </Box>
  );
}
